import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import InfoBar from '../InfoBar';
import BuildQuerySearch from './Components/BuildQuerySearch';
import BuildQueryStructureDrawing from './Components/BuildQueryStructureDrawing';
import BuildQueryHeading from './Components/BuildQueryHeading';
import BuildQuerySubHeading from './Components/BuildQuerySubHeading';

import './BuildQuery.scss';

function BuildQuery(props) {
  const { initialize, searchByQuery, query, structurePreview } = props;

  const handleKeyDown = (e) => {
    if (e.keyCode !== 13) {
      return;
    }
    searchByQuery();
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="build-query">
      <BuildQueryHeading {...props} />
      <section className={`${structurePreview ? 'build-query__wrapper--with-structure' : 'build-query__wrapper'}`} id="main-content">
        <BuildQuerySubHeading {...props} />
        <BuildQuerySearch {...props} />
        <BuildQueryStructureDrawing {...props} />
        <Button
          className="build-query__wrapper__searchbutton"
          onKeyDown={handleKeyDown}
          disabled={!query?.text?.length && !structurePreview}
          data-e2e="search query"
          onClick={searchByQuery}>
          Search
        </Button>
        <InfoBar />
      </section>
    </div>
  );
}

BuildQuery.propTypes = {
  initialize: PropTypes.func.isRequired,
};

export default BuildQuery;
